module.exports = __webpack_public_path__ + "static/media/por-logo.9f6b54c4.png";